import type { SupplementalAdQuality } from '@openx/types/deal.ts';

import { Filters, type SupplementalAdQualityFormState } from './constants.ts';

const optionsKeys = ['brands', 'languages', 'brand_labels', 'creative_types', 'content_attributes'] as const;

export function mapToFormState(adQuality?: SupplementalAdQuality | null): SupplementalAdQualityFormState {
  const state = getInitialState();

  if (!adQuality) return state;

  optionsKeys.forEach(key => {
    if (!adQuality[key]) return;
    state[key].op = adQuality[key].op as Filters;
    if (Array.isArray(adQuality[key].ids)) {
      state[key].ids = [...adQuality[key].ids];
    } else if (adQuality[key].ids) {
      state[key].ids = Object.keys(adQuality[key].ids);
    }
  });

  state.allow_unbranded_rtb_bids = adQuality.allow_unbranded_rtb_bids === '1';
  state.lean_filters = { ...adQuality.lean_filters };

  return state;
}

export function mapFromFormState(formState: SupplementalAdQualityFormState): SupplementalAdQuality {
  const state = {} as SupplementalAdQuality;

  optionsKeys.forEach(key => {
    if (formState[key].op === Filters.CURRENT) {
      state[key] = null;
      return;
    }

    state[key] = {
      op: formState[key].op,
      ids: [...formState[key].ids],
    };
  });

  state.allow_unbranded_rtb_bids = formState.allow_unbranded_rtb_bids ? '1' : '0';
  state.lean_filters = { ...formState.lean_filters };

  return state;
}

function getInitialState() {
  return {
    allow_unbranded_rtb_bids: false,
    brand_labels: { ids: [], op: 'current' },
    brands: { ids: [], op: 'current' },
    content_attributes: { ids: [], op: 'current' },
    creative_types: { ids: [], op: 'current' },
    languages: { ids: [], op: 'current' },
    lean_filters: {
      disable_pixel_buckets: '0',
      disable_total_requests_filter: '0',
    },
  } as SupplementalAdQualityFormState;
}
